export function formatMoneyFromCents(value?: string | number | null): string {
	const cents =
		typeof value === 'number'
			? value
			: typeof value === 'string'
				? Number(value)
				: Number.NaN

	if (!Number.isFinite(cents)) return ''

	const locale = window.Shopify?.locale || document.documentElement.lang || 'en-US'
	const currency = window.Shopify?.currency?.active || 'USD'

	try {
		return new Intl.NumberFormat(locale, {
			style: 'currency',
			currency,
		}).format(cents / 100)
	} catch {
		return `$${(cents / 100).toFixed(2)}`
	}
}

export function updateAtcPreorderLabel(
	labelEl: HTMLElement,
	inventoryStatusText: string,
	priceInCents?: string | number | null
) {
	const textEl =
		labelEl.querySelector<HTMLElement>('[data-uc-inventory-status-preorder-text]') ||
		labelEl.querySelector<HTMLElement>('[data-uc-inventory-status-instock-text]')
	const priceEl = labelEl.querySelector<HTMLElement>('.product-form__price')
	const formattedPrice = formatMoneyFromCents(priceInCents)

	if (textEl) {
		textEl.textContent = inventoryStatusText
	} else {
		labelEl.textContent = inventoryStatusText
	}

	if (priceEl && formattedPrice) {
		priceEl.textContent = formattedPrice
	}
}
